"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.customizeFilters = exports.buildDateFilterQuery = exports.buildQueryFromCategory = exports.createTicketPriceFilter = exports.createGameTagsFilters = exports.createGameTypeFilter = exports.filters = void 0;
const _ = __importStar(require("lodash"));
const TimeUtil_1 = require("../../utils/TimeUtil");
const filters_1 = require("../filters");
const GameStatus = {
    type: 'date',
    order: -3,
    header: 'game.filter.status.label',
    key: 'GameStatus',
    value: 'gameStatus',
    selectionType: filters_1.SelectionType.SINGLE,
    filters: [
        {
            order: 3,
            isSelected: false,
            name: 'game.filter.status.upcoming',
            value: 'upcoming',
            dateFilterType: 'upcoming'
        },
        {
            order: 0,
            isSelected: false,
            name: 'game.filter.status.active',
            value: 'active',
            dateFilterType: 'active'
        },
        {
            order: 2,
            isSelected: false,
            name: 'game.filter.status.new',
            value: 'new',
            dateFilterType: 'new'
        },
        {
            order: 1,
            isSelected: false,
            name: 'game.filter.status.endingSoon',
            value: 'endingSoon',
            dateFilterType: 'endingSoon'
        },
        {
            order: 4,
            isSelected: false,
            name: 'game.filter.status.ended',
            value: 'ended',
            dateFilterType: 'ended'
        }
    ]
};
const GameType = {
    type: 'type',
    order: -4,
    header: 'game.filter.gameTypeId.label',
    key: 'GameType',
    value: 'gameTypeId',
    selectionType: filters_1.SelectionType.SINGLE,
    filters: [
        {
            order: 0,
            isSelected: false,
            name: 'game.filter.gameTypeId.instant',
            value: '1'
        },
        {
            order: 1,
            isSelected: false,
            name: 'game.filter.gameTypeId.fastplay',
            value: '5'
        },
        {
            order: 2,
            isSelected: false,
            name: 'game.filter.gameTypeId.draw',
            value: '2'
        },
        {
            order: 3,
            isSelected: false,
            name: 'game.filter.gameTypeId.interactive',
            value: '3'
        },
        {
            order: 4,
            isSelected: false,
            name: 'game.filter.gameTypeId.eInstant',
            value: '4'
        },
        {
            order: 5,
            isSelected: false,
            name: 'game.filter.gameTypeId.quickdraw',
            value: '7'
        }
    ]
};
const TopPrize = {
    type: 'topprize',
    order: -2,
    header: 'game.filter.topPrize.label',
    key: 'TopPrize',
    value: 'queryTopPrize',
    selectionType: filters_1.SelectionType.MULTIPLE,
    filters: [
        {
            order: 0,
            isSelected: false,
            name: 'game.filter.topPrize.f1000000',
            value: 'f1000000'
        },
        {
            order: 1,
            isSelected: false,
            name: 'game.filter.topPrize.f500000',
            value: 'f500000'
        },
        {
            order: 2,
            isSelected: false,
            name: 'game.filter.topPrize.f250000-t500000',
            value: 'f250000-t500000'
        },
        {
            order: 3,
            isSelected: false,
            name: 'game.filter.topPrize.f100000-t250000',
            value: 'f100000-t250000'
        },
        {
            order: 4,
            isSelected: false,
            name: 'game.filter.topPrize.f50000-t100000',
            value: 'f50000-t100000'
        },
        {
            order: 5,
            isSelected: false,
            name: 'game.filter.topPrize.f5000-t50000',
            value: 'f5000-t50000'
        },
        {
            order: 6,
            isSelected: false,
            name: 'game.filter.topPrize.t5000',
            value: 't4999'
        },
        {
            order: 7,
            isSelected: false,
            name: 'game.filter.topPrize.other',
            value: 'other'
        }
    ]
};
const createGameTypeFilter = (gameTypes) => ({
    type: 'type',
    order: 0,
    header: 'game.filter.gameTypeId.label',
    key: 'GameType',
    value: 'gameTypeId',
    selectionType: filters_1.SelectionType.MULTIPLE,
    filters: gameTypes.map(x => ({
        name: x.name,
        value: x.id,
        isSelected: false,
        order: x.id
    }))
});
exports.createGameTypeFilter = createGameTypeFilter;
const createGameTagsFilters = (gameTagTypes, gameTags) => _.reduce(gameTagTypes, (result, gameTagType) => {
    const _filters = gameTags
        .filter(x => x.gameTagTypeId === gameTagType.id)
        .map(x => ({
        name: x.name,
        value: x.id,
        isSelected: false,
        order: x.id
    }));
    const key = gameTagType.name.replace(' ', '');
    const gameTagCategory = {
        type: 'tag',
        order: gameTagType.id,
        header: gameTagType.name,
        key,
        value: `query${gameTagType.name
            .split(' ')
            .map(x => _.startCase(x.toLowerCase()))
            .join('')}`,
        selectionType: filters_1.SelectionType.MULTIPLE,
        filters: _filters
    };
    return Object.assign(Object.assign({}, result), { [key]: gameTagCategory });
}, {});
exports.createGameTagsFilters = createGameTagsFilters;
const createTicketPriceFilter = (gameRetailerPrices) => ({
    type: 'price',
    order: -1,
    header: 'game.filter.retailPrice.label',
    key: 'TicketPrice',
    value: 'retailPrice',
    selectionType: filters_1.SelectionType.MULTIPLE,
    filters: gameRetailerPrices
        .filter(x => x > 0)
        .map(x => ({
        name: x.toCurrencyFormat(),
        value: x,
        isSelected: false,
        order: x
    }))
});
exports.createTicketPriceFilter = createTicketPriceFilter;
const buildDateFilterQuery = (_filters, newGamePeriod, upcomingGamePeriod) => {
    const query = [];
    _filters.forEach(filter => {
        if (filter.isSelected) {
            switch (filter.dateFilterType) {
                case 'new':
                    const period = (0, TimeUtil_1.nowUtc)().subtract(newGamePeriod, 'days');
                    query.push(`playBegin.greaterThanOrEqual=${period.toISOString()}&playBegin.lessThanOrEqual=${(0, TimeUtil_1.nowUtc)().toISOString()}`);
                    break;
                case 'active':
                    query.push(`playBegin.lessThanOrEqual=${(0, TimeUtil_1.nowUtc)().toISOString()}&active.equals=true`);
                    break;
                case 'upcoming':
                    const upcomingCutoff = (0, TimeUtil_1.nowUtc)().add(upcomingGamePeriod, 'days');
                    query.push(`playBegin.greaterThanOrEqual=${(0, TimeUtil_1.nowUtc)().toISOString()}&playBegin.lessThanOrEqual=${upcomingCutoff.toISOString()}`);
                    break;
                case 'endingSoon':
                    const endingCutoff = (0, TimeUtil_1.nowUtc)().add(upcomingGamePeriod, 'days');
                    query.push(`playEnd.lessThanOrEqual=${endingCutoff.toISOString()}&playEnd.greaterThanOrEqual=${(0, TimeUtil_1.nowUtc)().toISOString()}`);
                    break;
                case 'ended':
                    query.push(`playEnd.lessThanOrEqual=${(0, TimeUtil_1.nowUtc)().toISOString()}`);
                    break;
                default:
                    const defaultPeriod = (0, TimeUtil_1.nowUtc)().subtract(newGamePeriod, 'days');
                    query.push(`playBegin.greaterThanOrEqual=${defaultPeriod.toISOString()}&playBegin.lessThanOrEqual=${(0, TimeUtil_1.nowUtc)().toISOString()}`);
                    break;
            }
        }
    });
    return query;
};
exports.buildDateFilterQuery = buildDateFilterQuery;
const buildQueryFromCategory = (filterCategory, newGamePeriod, upcomingGamePeriod) => {
    if (filterCategory.type === 'date') {
        return buildDateFilterQuery(_.filter(filterCategory.filters, filter => filter.isSelected), newGamePeriod, upcomingGamePeriod);
    }
    const query = [];
    const selectedFilters = _.filter(filterCategory.filters, filter => filter.isSelected);
    if (selectedFilters && selectedFilters.length > 0) {
        let queryStr = _.map(selectedFilters, ({ value }) => value).join(',');
        switch (filterCategory.type) {
            case 'topprize':
            case 'tag':
                queryStr = `${filterCategory.value}=${queryStr}`;
                break;
            case 'type':
            case 'price':
                queryStr = `${filterCategory.value}.in=${queryStr}`;
                break;
            default:
                break;
        }
        if (queryStr) {
            query.push(queryStr);
        }
    }
    return query;
};
exports.buildQueryFromCategory = buildQueryFromCategory;
const customizeFilters = (filtersToCustomize, gameStatuses, topPrizes, gameTypes, isGameTypeMultiSelect) => {
    const customize = (filterCategory, filterValues, isMultiSelect) => {
        if (!filterValues) {
            return filterCategory;
        }
        if (filterCategory.filters) {
            filterCategory.filters = filterCategory.filters
                .filter(filter => filterValues.includes(filter.value))
                .sort((x, y) => filterValues.indexOf(x.value) - filterValues.indexOf(y.value));
        }
        if (!!isMultiSelect) {
            filterCategory.selectionType = filters_1.SelectionType.MULTIPLE;
        }
        return filterCategory;
    };
    return Object.assign(Object.assign({}, filtersToCustomize), { GameType: customize(filtersToCustomize.GameType, gameTypes, isGameTypeMultiSelect), GameStatus: customize(filtersToCustomize.GameStatus, gameStatuses), TopPrize: customize(filtersToCustomize.TopPrize, topPrizes) });
};
exports.customizeFilters = customizeFilters;
const filters = {
    GameStatus,
    TopPrize,
    GameType
};
exports.filters = filters;
//# sourceMappingURL=filters.js.map